import { clearOwnedAuthStorage } from '../sessionState.mjs';

const getBrowserStorage = (scope) => {
    if (typeof window === 'undefined') return null;
    return scope === 'local' ? window.localStorage : window.sessionStorage;
};

const deserialize = (value, defaultValue) => {
    if (value === null || value === undefined) return defaultValue;

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

const serialize = (value) => (
    typeof value === 'string' ? value : JSON.stringify(value)
);

const createStorage = (scope) => ({
    async get(key, defaultValue = null) {
        try {
            const storage = getBrowserStorage(scope);
            return storage ? deserialize(storage.getItem(key), defaultValue) : defaultValue;
        } catch {
            return defaultValue;
        }
    },

    async set(key, value) {
        const storage = getBrowserStorage(scope);
        if (!storage) return;

        if (value === undefined || value === null) {
            storage.removeItem(key);
            return;
        }

        storage.setItem(key, serialize(value));
    },

    async remove(key) {
        getBrowserStorage(scope)?.removeItem(key);
    }
});

const session = createStorage('session');
const preferences = createStorage('local');

export const webSessionStorage = Object.freeze({
    ...session,

    async clearAuth() {
        clearOwnedAuthStorage(
            getBrowserStorage('session'),
            getBrowserStorage('local')
        );
    }
});

export const webPreferences = Object.freeze(preferences);
